import { FormControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function noWhitespaceValidator(): ValidatorFn {
    return (control: FormControl): ValidationErrors | null => {
        if (!control) {
            throw new Error("FormControl is undefined/null");
        }
        const isWhitespace = !((control.value as string) || "").trim().length;
        const isValid = !isWhitespace;
        return isValid ? null : { whitespace: true };
    };
}
